import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import { DateTime } from 'components/Erp/Display';
import React from 'react'
import { Map, MapPin, Network, Search, ChevronLeft, ChevronRight } from 'lucide-react'
import s from './PanelBase.module.scss'
import { SectionHeading, EmptyState } from 'components/Erp/Presentation'
import MiniMap from 'pages/ReportCard/MiniMap'

const ReadOnlyBranchesList = ({
  base,
  baseType = tr("базы"),
  branches = [],
  branchesFilter = '',
  setBranchesFilter = () => {},
  loadBranchesPage = () => {},
  branchesPagination = {},
}) => {
  useInterfaceLanguage();
  const filtered = branches.filter(b => {
    const q = (branchesFilter || '').toLowerCase()
    if (!q) return true
    return (b.name && b.name.toLowerCase().includes(q)) || (b.address && b.address.toLowerCase().includes(q))
  })

  return (
    <div className={s.subPanel}>
      <SectionHeading icon={Network} title={tr("Филиалы этой {{value0}}", { value0: tr(baseType) })} as="h3" />

      <div className={s.searchRow}>
        <Search size={16} aria-hidden="true" />
        <input
          className={s.searchInput}
          placeholder={tr("Поиск по филиалу...")}
          value={branchesFilter || ''}
          onChange={(e) => setBranchesFilter(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') loadBranchesPage(base.id, 1, branchesFilter || '') }}
        />
      </div>

      {filtered.length ? (
        <>
          <div className={s.tableWrap}>
            <div className={s.tableScroll}>
            <table className={s.table}>
              <thead>
                <tr>
                  <th>№</th>
                  <th>{tr("Название")}</th>
                  <th>{tr("Адрес")}</th>
                  <th>{tr("Местоположение")}</th>
                  <th>{tr("Создано")}</th>
                  <th>{tr("Статус")}</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((b, index) => (
                  <tr key={b.id}>
                    <td data-label={tr("№")} className={s.numCell}>{tr(index + 1)}</td>
                    <td data-label={tr("Название")} style={{ fontWeight: 600, color: "var(--theme-text, #1e293b)" }}>{tr(b.name || '—')}</td>
                    <td data-label={tr("Адрес")} style={{ color: "var(--theme-text-muted, #64748b)" }}>{tr(b.address || '—')}</td>
                    <td data-label={tr("Местоположение")}>
                      {b.geo ? (
                        <div style={{ display: 'flex', gap: '6px', flexDirection: 'column' }}>
                          <div style={{ display: 'flex', gap: '6px' }}>
                            <button onClick={() => window.open(`https://www.google.com/maps?q=${b.geo}`, '_blank')} className={s.geoBtn}><Map size={14} aria-hidden="true" />{tr(" Карты")}</button>
                            <button onClick={() => { const el = document.getElementById(`branch-map-${b.id}`); if (el) el.style.display = el.style.display === 'none' ? 'block' : 'none' }} className={s.mapToggleBtn} aria-label={tr("Показать или скрыть мини-карту")}><MapPin size={15} aria-hidden="true" /></button>
                          </div>
                          <div id={`branch-map-${b.id}`} style={{ width: 200, height: 150, display: 'none' }}>
                            <MiniMap geo={b.geo} />
                          </div>
                        </div>
                      ) : '—'}
                    </td>
                    <td data-label={tr("Создано")} style={{ fontSize: 12, color: "var(--theme-text-muted, #64748b)" }}><DateTime value={b.created_at} /></td>
                    <td data-label={tr("Статус")}>
                      <span className={`${s.badge} ${b.is_active ? s.active : s.inactive}`}>
                        {b.is_active ? tr("Активен") : tr("Неактивен")}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </div>

          {tr(!branchesFilter && branchesPagination?.count > 0 && (
            <div className={s.pagination}>
              <button className={s.pageBtn} disabled={!branchesPagination.previous} onClick={() => loadBranchesPage(base.id, (branchesPagination.page || 1) - 1)}><ChevronLeft size={15} aria-hidden="true" />{tr("Пред.")}</button>
              <span>{tr("Стр. ")}{tr(branchesPagination.page || 1)}{tr(" из ")}{Math.ceil(branchesPagination.count / 25)}</span>
              <button className={s.pageBtn} disabled={!branchesPagination.next} onClick={() => loadBranchesPage(base.id, (branchesPagination.page || 1) + 1)}>{tr("След.")}<ChevronRight size={15} aria-hidden="true" /></button>
            </div>
          ))}
        </>
      ) : (
        <EmptyState icon={Network} title={tr("Филиалы не найдены")} description={tr("Измените поисковый запрос или выберите другой объект.")} compact />
      )}
    </div>
  )
}

export default ReadOnlyBranchesList
